// Replace direct database calls with API calls to backend

export async function getPostReplies(postId: string | number, skip: number = 0) {
  try {
    const params = new URLSearchParams({
      skip: skip.toString(),
      limit: '10'
    });
    
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts/${postId}/replies?${params}`);
    if (!response.ok) {
      throw new Error('Failed to fetch replies');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching replies:', error);
    throw error;
  }
}

export async function createReply(data: {
  content: string;
  postId: number;
  userId: string;
  name: string;
  username: string;
  image?: string;
  files?: string[];
}) {
  try {
    const token = localStorage.getItem('auth_token');
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts/${data.postId}/replies`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        content: data.content,
        files: data.files || []
      })
    });
    
    if (!response.ok) {
      throw new Error('Failed to create reply');
    }
    return await response.json();
  } catch (error) {
    console.error('Error creating reply:', error);
    throw error;
  }
}